window.initGlobberMap = function() {
    console.log('initGlobberMap called');
    const $ = jQuery;
    const store_locator = $('.store-locator__map');

    console.log('store_locator elements found:', store_locator.length);

    if (typeof STORE_ARRAY === 'undefined') {
        console.error('STORE_ARRAY is undefined');
        return;
    }
    console.log('STORE_ARRAY:', STORE_ARRAY);

    if (!store_locator.length) {
        console.warn('No .store-locator__map element found');
        return;
    }

    store_locator.each(function () {
        const map_container = $(this);
        console.log('Initializing map for container:', map_container[0]);
        initMap(map_container[0]);
    });
};

(function ($) {
    // If Google Maps is already loaded (e.g. cached or loaded by another plugin), init immediately
    if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
        console.log('Google Maps already loaded, calling initGlobberMap directly');
        window.initGlobberMap();
    } else {
        console.log('Google Maps not yet loaded');
    }

    $('#location-choose').on('change', function () {
        const url = new URL(window.location.href);
        url.searchParams.set('country_code', this.value);
        window.location.href = url.toString();
    });

}(jQuery));

// Helper function for map initialization
function initMap(map_container) {
    console.log('initMap called');
    const locations = STORE_ARRAY;
    const icon = (typeof THEME_URL !== 'undefined' ? THEME_URL : '') + '/build/img/svg/marker.svg';
    
    if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        console.error('Google Maps API not available inside initMap');
        return;
    }

    const map = new google.maps.Map(map_container, {
        center: new google.maps.LatLng(20.59, 78.96),
        mapTypeId: 'roadmap',
        mapTypeControl: false,
        streetViewControl: false,
        panControl: false,
        zoom: 8,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM
        },
    });

    console.log('Map object created:', map);

    const infowindow = new google.maps.InfoWindow({
        maxWidth: 235
    });

    const markers = [];

    // Add the markers and infowindows to the map
    locations.forEach((location, i) => {
        const lat = parseFloat(location.latitude);
        const long = parseFloat(location.longitude);
        
        if (isNaN(lat) || isNaN(long)) {
            console.warn('Invalid coordinates for location:', location);
            return;
        }

        const marker = new google.maps.Marker({
            position: new google.maps.LatLng(lat, long),
            map: map,
            icon: icon,
            title: 'Click to zoom'
        });

        markers.push(marker);

        google.maps.event.addListener(marker, 'click', function () {
            const description = location.description && location.description.length > 1 ? '<p>' + location.description + '</p>' : '';
            const title = location.title && location.title.length > 1 ? '<h3>' + location.title + '</h3>' : '';
            const address = location.address && location.address.length > 1 ? '<p>' + location.address + '</p>' : '';
            
            infowindow.setContent('<div class="map-marker">' + title + address + description + '</div>');
            infowindow.open(map, marker);
            map.setZoom(8);
            map.setCenter(marker.getPosition());
        });
    });
    
    console.log('Markers created:', markers.length);

    // Event delegation for list items
    jQuery(document).on('click', '.store-locator__show-on-map', function (e) {
        e.preventDefault();
        const index = jQuery(this).data('store-index');
        if (markers[index]) {
            google.maps.event.trigger(markers[index], 'click');
        }
    });

    function autoCenter() {
        const bounds = new google.maps.LatLngBounds();
        markers.forEach(marker => {
            bounds.extend(marker.position);
        });
        if (markers.length > 0) {
            map.fitBounds(bounds);
        }
    }
    
    autoCenter();

    setTimeout(function () {
        const firstLink = jQuery('.store-locator__show-on-map').first();
        if (firstLink.length) {
            const index = firstLink.data('store-index');
            if (markers[index]) {
                google.maps.event.trigger(markers[index], 'click');
            }
        }
    }, 500);
}